import React from 'react';
import './DashboardHeader.css';

const DashboardHeader = ({ title = "Dashboard", searchQuery = "", onSearchChange, onLogout }) => {
  const handleInputChange = (e) => {
    const val = e.target.value;
    if (onSearchChange) {
      onSearchChange(val);
    }
  };

  const handlePaste = (e) => {
    const pastedText = e.clipboardData ? e.clipboardData.getData('text') : '';
    if (pastedText && onSearchChange) {
      const cleanText = pastedText.replace(/[\r\n]+/g, ' ').trim();
      setTimeout(() => {
        onSearchChange(cleanText);
      }, 0);
    }
  };

  // Format today's date nicely
  const todayFormatted = new Date().toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  });

  return (
    <header className="dashboard-header">
      <div className="header-left-col">
        <div className="header-title-wrap">
          <h1>{title}</h1>
          <div className="header-meta-chips">
            <span className="live-sync-chip">
              <span className="sync-pulse-dot"></span>
              Live Synced
            </span>
            <span className="header-date-chip">
              <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '5px' }}>
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              {todayFormatted}
            </span>
          </div>
        </div>
      </div>

      <div className="header-actions">
        {/* Global Search Bar with Shortcut hint */}
        <div className="search-bar">
          <svg className="search-icon" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input 
            type="text" 
            placeholder="Search records, users, orders..." 
            value={searchQuery || ''}
            onChange={handleInputChange}
            onInput={handleInputChange}
            onPaste={handlePaste}
            autoComplete="off"
            spellCheck="false"
          />
          {searchQuery ? (
            <button 
              className="clear-search-btn" 
              onClick={() => onSearchChange && onSearchChange('')}
              title="Clear search"
              type="button"
            >
              ✕
            </button>
          ) : (
            <span className="kbd-shortcut-hint">/</span>
          )}
        </div>

        {/* Refresh / Sync Quick Button */}
        <button 
          className="header-icon-action-btn" 
          title="Reload Data" 
          onClick={() => window.location.reload()}
          type="button"
        >
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"></path>
          </svg>
        </button>

        {/* Notifications Icon with Badge */}
        <button className="header-icon-action-btn" title="System Notifications" type="button">
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
          <span className="badge-dot"></span>
        </button>

        {/* Primary Action Button */}
        <button 
          className="primary-action-btn" 
          onClick={() => {
            const btn = document.querySelector('.add-btn');
            if (btn) btn.click();
          }}
        >
          <span className="btn-plus-icon">+</span> New Entry
        </button>

        {/* Header Logout */}
        <button 
          className="header-logout-btn" 
          onClick={onLogout}
          title="Log Out of Dashboard"
        >
          <svg className="logout-svg-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          <span>Log Out</span>
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;
